/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import BaseViewerManagerController, {
  getContentTasks
} from './base-viewer-manager-controller';

/**
 * @import { ViewerManagerController } from '.'
 * @import { IAnalyticsTracker } from '../../analytics'
 * @import { ContentInfo } from '../../content/info/content-info'
 * @import { ContentTaskCronFactory } from '../../content/task/cron/content-task-cron-factory'
 * @import { ContentControllerFactory } from '../../content/controller/'
 * @import { Logger } from '../../logger/logger'
 */

/**
 * @implements {ViewerManagerController}
 */
export default class HiddenController extends BaseViewerManagerController {
  /**
   * @param {IAnalyticsTracker} analyticsTracker
   * @param {ContentControllerFactory} contentControllerFactory
   * @param {ContentInfo} contentInfo
   * @param {ContentTaskCronFactory} contentTaskCronFactory
   * @param {HTMLElement} el
   * @param {Logger} logger
   * @param {string} target
   */
  constructor(
    analyticsTracker,
    contentControllerFactory,
    contentInfo,
    contentTaskCronFactory,
    el,
    logger,
    target
  ) {
    const hiddenEl = document.createElement('div');
    hiddenEl.style.display = 'none';
    el.appendChild(hiddenEl);

    super(
      analyticsTracker,
      contentControllerFactory,
      contentInfo,
      contentTaskCronFactory,
      hiddenEl,
      undefined,
      logger
    );
    /** @type {HTMLElement} */
    this.parentEl = el;
    /** @type {string} */
    this.target = target;
  }

  /** @type {ViewerManagerController['start']} */
  async start() {
    await super.preload(
      getContentTasks(this.contentInfo.contentTasks, this.target)
    );
    await super.start();
  }

  /** @type {ViewerManagerController['stop']} */
  async stop() {
    try {
      await super.stop();
    } finally {
      this.parentEl.removeChild(this.el);
    }
  }
}
